import { useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { Save, Search } from 'lucide-react';

const TEXT_POSITIONS = [
  { value: '0', label: 'Сверху' },
  { value: '1', label: 'Справа' },
  { value: '2', label: 'Снизу' },
  { value: '3', label: 'Слева' },
];

export function EditObjectSheet({ 
  title,
  numberLabel,
  initialNumber, 
  initialLinkedtp,
  initialTextPosition,
  searchLink,
  onClose, 
  onSave,
  onBack 
}) {
  const [number, setNumber] = useState(initialNumber);
  const [linkedtp, setLinkedtp] = useState(initialLinkedtp);
  const [position, setPosition] = useState(String(initialTextPosition));
  const [error, setError] = useState('');
  
  // Поиск питающего центра
  const [query, setQuery] = useState(initialLinkedtp || '');
  const [results, setResults] = useState([]);

  const handleSearch = async (text) => {
    setQuery(text);
    setLinkedtp(null);
    if (text.length < 2) {
      setResults([]);
      return;
    }
    try {
      const response = await fetch(`${searchLink}${encodeURIComponent(text)}`);
      const data = await response.json();
      setResults(data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectLinkedtp = (obj) => {
    setLinkedtp(obj.name);
    setQuery(obj.name);
    setResults([]);
    setError('');
  };

  const handleSave = () => {
    if (!linkedtp) { // ← добавить проверку
      setError('Не выбран питающий центр');
      return;
    }
    onSave(number, linkedtp, parseInt(position));
  };

  return (
    <BottomSheet title={title} onClose={onClose} open={true} onBack={onBack} modal={true}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

        {error && (
          <span style={{ fontSize: '13px', color: '#ef4444', marginTop: '4px', display: 'block' }}>
            {error}
          </span>
        )}

        {/* Номер */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            {numberLabel}
          </label>
          <input
            type="text"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 16px',
              fontSize: '15px',
              border: '1px solid #e5e5e5',
              borderRadius: '12px',
              background: '#f9f9f9',
              boxSizing: 'border-box',
              outline: 'none'
            }}
          />
        </div>

        {/* Питающий центр */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Питающий центр
          </label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              value={query}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Поиск..."
              style={{
                width: '100%',
                padding: '12px 16px',
                fontSize: '15px',
                border: '1px solid #e5e5e5',
                borderRadius: '12px',
                background: '#f9f9f9',
                boxSizing: 'border-box',
                outline: 'none'
              }}
            />
          </div>

          {/* Результаты поиска */}
          {results.length > 0 && (
            <div style={{
              marginTop: '4px',
              border: '1px solid #f0f0f0',
              borderRadius: '12px',
              overflow: 'hidden',
              maxHeight: '150px',
              overflowY: 'auto',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}>
              {results.map((obj, index) => (
                <div
                  key={obj.id}
                  onClick={() => handleSelectLinkedtp(obj)}
                  style={{
                    padding: '12px 16px',
                    fontSize: '14px',
                    color: '#1a1a1a',
                    borderBottom: index !== results.length - 1 ? '1px solid #f5f5f5' : 'none',
                    cursor: 'pointer',
                    background: 'white'
                  }}
                >
                  {obj.name}
                </div>
              ))}
            </div>
          )}

          {/* Выбранный питающий центр */}
          {linkedtp && (
            <div style={{
              marginTop: '8px',
              padding: '10px 14px',
              background: '#eff6ff',
              borderRadius: '10px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#3b82f6' }} />
              <span style={{ fontSize: '14px', color: '#1d4ed8', fontWeight: 500 }}>
                {linkedtp}
              </span>
            </div>
          )}
        </div>

        {/* Расположение номера */}
        <div>
          <label style={{ fontSize: '13px', color: '#888', display: 'block', marginBottom: '8px' }}>
            Расположение номера
          </label>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {TEXT_POSITIONS.map((pos) => (
              <button
                key={pos.value}
                onClick={() => setPosition(pos.value)}
                style={{
                  padding: '12px',
                  borderRadius: '12px',
                  border: 'none',
                  fontSize: '14px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  background: position === pos.value ? '#3b82f6' : '#f5f5f5',
                  color: position === pos.value ? 'white' : '#1a1a1a',
                  transition: 'all 0.15s'
                }}
              >
                {pos.label}
              </button>
            ))}
          </div>
        </div>

        {/* Кнопка сохранить */}
        <button
          onClick={handleSave}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            padding: '16px',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            fontSize: '15px',
            fontWeight: 600,
            cursor: 'pointer',
            width: '100%'
          }}
        >
          <Save size={18} />
          Сохранить
        </button>

      </div>
    </BottomSheet>
  );
}